import Helmet from 'react-helmet'
import React from 'react'
import { observer } from 'mobx-react'
import PaddedBlock from 'components/PaddedBlock'
import Icon from 'components/Icon'
import FlexCenter from 'components/FlexCenter'
import FileButton from 'components/FileButton'
import Document from 'components/Document'
import intercomUpdate from 'decorators/intercomUpdate'
import ProgressSpinner from 'components/ProgressSpinner'
import { HeaderSink, HeaderTitle } from 'components/Header'

@intercomUpdate({ screen: 'Documents' })
@observer
export default class DocumentsScreen extends React.Component {
  componentWillMount () {
    this.props.rootStore.documentsScreenStore.activate()
  }

  renderLoader = () => (
    <FlexCenter>
      <ProgressSpinner blue />
    </FlexCenter>
  )

  renderNoDocuments = () => (
    <PaddedBlock className="no-documents has-text-centered">
      <img src={require('assets/icons/docs.png')} alt="No Documents"/>
      <div className="content has-vspacing">
        <p>
          No documents have been uploaded yet.
        </p>
      </div>
    </PaddedBlock>
  )

  renderDocuments = (store) => (
    store.documents.map((document) => (
      <div className="has-spacing-bottom" key={document.cid}>
        <Document
          onEditClick={() => store.rootStore.documentStore.editDocument(document)}
          document={document}
          canChangeCategory
        />
      </div>
    ))
  )

  render () {
    const store = this.props.rootStore.documentsScreenStore
    return (
      <div className="documents-screen">
        <Helmet title="Documents" />
        <HeaderSink small>
          <HeaderTitle>
            Documents
          </HeaderTitle>
        </HeaderSink>
        <div className="has-vspacing">
          <div className="container">
            <div className="columns">
              <div className="column is-6 is-offset-3">
                <div className="has-text-centered has-spacing-bottom">
                  {store.loading === false &&
                    <FileButton onChange={files => store.rootStore.documentStore.stageFiles('PERSONAL', files)}>
                      <a className="button is-medium is-document-action">
                        <span className="icon">
                          <Icon material name="cloud upload" />
                        </span>
                        <span>
                          Upload Document
                        </span>
                      </a>
                    </FileButton>
                  }
                </div>
                {store.loading
                  ? this.renderLoader()
                  : store.documents.length
                      ? this.renderDocuments(store)
                      : this.renderNoDocuments()
                }
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/Documents/index.jsx